import React from 'react';
import { Route } from 'react-router-dom';

import CoursePage from '../CoursePage';
import CourseListPage from '../CourseListPage';

export default function CourseApp() {
  return (
    <>
      <Route exact path="/" render={() => <CourseListPage />} />
      <Route
        path="/:courseId"
        render={props => <CoursePage courseId={props.match.params.courseId} />}
      />
    </>
  );
}
